import React from "react" 
import { Link } from 'react-router-dom'
import TagManager from 'react-gtm-module';
import { getImgUrl } from '../../Utility/Utility'
import {  Img  } from '../../Components/UI/UI'
import "./Footer.css"

const Footer = () => { 
  return(
    <div className="Footer-outer-wrapper">
            <div className="container">
             <div className="row">
                        <div className="col col-100 footer-menu-outer-wrapper">
                              
                              <div className="footer-images-wrapper"> 
                                          {/* <div className="tripadvisor-main-wrapper">
                                                <Img desktopImg="Footer/tripadvisorMain.png" />
                              </div> */}
                                    
                              {/* <div className="info-main-wrapper">
                                                <a href="https://virtual.goisrael.com/" onClick={()=>TagManager.dataLayer({dataLayer: {'event':'auto_event','eventName':'link_click', 'element_location':'footer', 'click_cta':'tourist info', }})}>
                                                      <Img desktopImg="touristinfo.jpg" />
                                                </a>
                              </div> */}
                              <div className="clear"></div>

                                    
                              </div>
                              
                        <div className="footer-menu-inner-wrapper footer-menu-inner-wrapper-1">
                              <ul className="first">  
                                    <li>
                                          <Link  className="first" to="/Pages/SitesOfSignificance" onClick={()=>TagManager.dataLayer({dataLayer: {'event':'auto_event','eventName':'generic_ click', 'element_location':'footer', 'click_cta':'sites to significance', 'event_details':'', }})}>SITES TO SIGNIFICANCE</Link>
                                    </li>
                                    <li className="show-on-mobile">
                                          <a>|</a>
                                    </li>
                                   <li>
                                          <Link to="/Pages/JerusalemPage" onClick={()=>TagManager.dataLayer({dataLayer: {'event':'auto_event','eventName':'generic_ click', 'element_location':'footer', 'click_cta':'jerusalem', 'event_details':'', }})}>JERUSALEM</Link>
                                    </li>
                                    <li className="show-on-mobile">
                                          <a>|</a>
                                    </li>
                                    <li>
                                          <Link to="/Pages/GalileePage" onClick={()=>TagManager.dataLayer({dataLayer: {'event':'auto_event','eventName':'generic_ click', 'element_location':'footer', 'click_cta':'galilee', 'event_details':'', }})}>GALILEE</Link>
                                    </li>
                                    <li className="show-on-mobile">
                                          <a>|</a>
                                    </li>
                                    <li>
                                          <Link to="/Pages/CoastalPlainPage" onClick={()=>TagManager.dataLayer({dataLayer: {'event':'auto_event','eventName':'generic_ click', 'element_location':'footer', 'click_cta':'coastal plain', 'event_details':'', }})}>COASTAL PLAIN</Link>
                                    </li>
                                    <li className="show-on-mobile">
                                          <a>|</a>
                                    </li>
                                    <li>
                                          <Link to="/Pages/ValleyDesertPage" onClick={()=>TagManager.dataLayer({dataLayer: {'event':'auto_event','eventName':'generic_ click', 'element_location':'footer', 'click_cta':'jordan valley & judean desert', 'event_details':'', }})}>JORDAN VALLEY & JUDEAN DESERT</Link>
                                    </li>
                                    <li className="show-on-mobile">
                                          <a>|</a>
                                    </li>
                              </ul>


                              <ul>
                                    <li>
                                          <Link className="first" to="/Pages/ItinerariesPage" onClick={()=>TagManager.dataLayer({dataLayer: {'event':'auto_event','eventName':'generic_ click', 'element_location':'footer', 'click_cta':'itineraries', 'event_details':'', }})}>ITINERARIES</Link>
                                    </li>
                                    <li className="show-on-mobile">
                                          <a>|</a>
                                    </li>
                                    {/* <li>
                                          <Link to="/Posts/itineraries/Catholic-7_Day_Itinerary">CATHOLIC 7 DAY</Link>
                                    </li>
                                    <li className="show-on-mobile">
                                          <a>|</a>
                                    </li> */}
                                    <li>
                                          <Link to="/Posts/itineraries/First_Timers_7_Day_Tour" onClick={()=>TagManager.dataLayer({dataLayer: {'event':'auto_event','eventName':'generic_ click', 'element_location':'footer', 'click_cta':'7 days', 'event_details':'', }})}>7 DAYS</Link>
                                    </li>
                                    <li className="show-on-mobile">
                                          <a>|</a>
                                    </li>
                                    <li>
                                          <Link to="/Posts/itineraries/Christian_Interest_Itinerary_10_Days_Tour" onClick={()=>TagManager.dataLayer({dataLayer: {'event':'auto_event','eventName':'generic_ click', 'element_location':'footer', 'click_cta':'10 days', 'event_details':'', }})}>10 DAYS</Link>
                                    </li>
                                    <li className="show-on-mobile">
                                          <a>|</a>
                                    </li>                               
                                    
                              </ul> 
                              <ul className="">
                                    <li>
                                          <Link className="first" to="/" onClick={()=>TagManager.dataLayer({dataLayer: {'event':'auto_event','eventName':'generic_ click', 'element_location':'footer', 'click_cta':'general', 'event_details':'', }})}>GENERAL</Link>
                                    </li>
                                    <li className="show-on-mobile">
                                          <a>|</a>
                                    </li>
                                    <li>
                                          <Link to="/Pages/CoronaVirusPage" onClick={()=>TagManager.dataLayer({dataLayer: {'event':'auto_event','eventName':'generic_ click', 'element_location':'footer', 'click_cta':'latest information and updates', 'event_details':'', }})}>LATEST INFORMATION AND UPDATES</Link>
                                    </li>
                                    <li className="show-on-mobile">
                                          <a>|</a>
                                    </li>
                                    <li>
                                          <a href="https://info.goisrael.com/en/office-abroad" onClick={()=>TagManager.dataLayer({dataLayer: {'event':'auto_event','eventName':'generic_ click', 'element_location':'footer', 'click_cta':'israel govermant tourism offices', 'event_details':'', }})}>ISRAEL GOVERNMENT TOURISM OFFICES</a>
                                    </li>
                                    <li className="show-on-mobile">
                                          <a>|</a>     
                                    </li>                       
                              </ul>

                              <div className="clear"></div>
                    </div>
                  <div className="clear"></div>
                  
                    </div>
             </div>
             <div className="ac-social-wrapper">
                  <div className="ac-inner-social-wrapper">
                        <div className="ac-social-col ac-social-col-1">
                              <a href="https://www.instagram.com/holylandpics/" onClick={()=>TagManager.dataLayer({dataLayer: {'event':'auto_event','eventName':'generic_ click', 'element_location':'footer', 'click_cta':'instagram', 'event_details':'', }})}>
                              <Img desktopImg="social/i.png" mobileImg="social/i.png"/>
                              </a>
                        </div>
                        {/* <div className="ac-social-col ac-social-col-2">
                              <a href="https://twitter.com/israeltourism" onClick={()=>TagManager.dataLayer({dataLayer: {'event':'auto_event','eventName':'generic_ click', 'element_location':'footer', 'click_cta':'twitter', 'event_details':'', }})}>
                              <Img desktopImg="social/t.png" mobileImg="social/t.png"/>
                              </a>
                        </div> */}
                        <div className="ac-social-col ac-social-col-3">
                              <a href="https://www.youtube.com/user/goisraelofficial" onClick={()=>TagManager.dataLayer({dataLayer: {'event':'auto_event','eventName':'generic_ click', 'element_location':'footer', 'click_cta':'youtube', 'event_details':'', }})}>
                              <Img desktopImg="social/y.png" mobileImg="social/y.png"/>
                              </a>
                        </div>
                        <div className="ac-social-col ac-social-col-4">
                              <a href="https://www.flickr.com/photos/israelphotogallery/sets/" onClick={()=>TagManager.dataLayer({dataLayer: {'event':'auto_event','eventName':'generic_ click', 'element_location':'footer', 'click_cta':'flickr', 'event_details':'', }})}>
                              <Img desktopImg="social/fl.png" mobileImg="social/fl.png"/>
                              </a>
                        </div>
                        <div className="ac-social-col ac-social-col-5">
                              <a href="https://www.facebook.com/HolyLandSpirit" onClick={()=>TagManager.dataLayer({dataLayer: {'event':'auto_event','eventName':'generic_ click', 'element_location':'footer', 'click_cta':'facebook', 'event_details':'', }})}>
                              <Img desktopImg="social/f.png" mobileImg="social/f.png"/>
                              </a>
                        </div>
                        <div className="ac-social-col ac-social-col-6">
                              <a href="https://www.tiktok.com/@visit_israel" onClick={()=>TagManager.dataLayer({dataLayer: {'event':'auto_event','eventName':'generic_ click', 'element_location':'footer', 'click_cta':'tiktok', 'event_details':'', }})}>
                              <Img desktopImg="social/tiktok.png" mobileImg="social/tiktok.png"/>
                              </a>
                        </div>
                        <div className="ac-social-col ac-social-col-7">
                              <a href="https://www.linkedin.com/company/israel-ministry-of-tourism/" onClick={()=>TagManager.dataLayer({dataLayer: {'event':'auto_event','eventName':'generic_ click', 'element_location':'footer', 'click_cta':'linkedin', 'event_details':'', }})}>
                              <Img desktopImg="social/linkedin.png" mobileImg="social/linkedin.png"/>
                              </a>
                        </div>
                  </div>
            </div>
             <div className="row">

                        <div className="cradit">
                              <p>
                                    Photographers: Guy Yehieli, Adam Primer, Kfir Boltin, Linnea Andres, Kfir Sivan, Haim Yafim, Dana Fridlander, refael Ben Ari, Itamar Greenberg, Moshik Lindbaum, Ori Ackerman
                              </p>
                              <p>
                                    Video Credits: Israeli food channel, Tel Aviv Jaffa municipality, UDINI prodactions
                              </p>
                        </div>
                       

                        
                        <div className="clear"></div>

                        <nav className="footer-nav">
                              <a href="https://brochures.goisrael.com/" onClick={()=>TagManager.dataLayer({dataLayer: {'event':'auto_event','eventName':'generic_ click', 'element_location':'footer', 'click_cta':'official brochure', 'event_details':'', }})}>OFFICIAL BROCHURE</a> <span className="ac-ver-line"> | </span>
                              <a href="https://goisrael.com/Pages/Contact/" onClick={()=>TagManager.dataLayer({dataLayer: {'event':'auto_event','eventName':'generic_ click', 'element_location':'footer', 'click_cta':'contact us', 'event_details':'', }})}>CONTACT US</a> <span className="ac-ver-line"> | </span>
                              <a href="https://israel.travel/terms-of-use/" onClick={()=>TagManager.dataLayer({dataLayer: {'event':'auto_event','eventName':'generic_ click', 'element_location':'footer', 'click_cta':'term of use', 'event_details':'', }})}>TERMS OF USE</a> <span className="ac-ver-line"> | </span>
                              <a href="https://goisrael.com/Posts/telaviv/Privacy_Policy" onClick={()=>TagManager.dataLayer({dataLayer: {'event':'auto_event','eventName':'generic_ click', 'element_location':'footer', 'click_cta':'privacy policy', 'event_details':'', }})}>PRIVACY POLICY</a> <span className="ac-ver-line"> | </span>
                              <Link to="/Pages/Gallery/" onClick={()=>TagManager.dataLayer({dataLayer: {'event':'auto_event','eventName':'generic_ click', 'element_location':'footer', 'click_cta':'gallery', 'event_details':'', }})}>GALLERY</Link> <span className="ac-ver-line"> | </span>
                              <Link to="/Pages/FAQ" onClick={()=>TagManager.dataLayer({dataLayer: {'event':'auto_event','eventName':'generic_ click', 'element_location':'footer', 'click_cta':'faq', 'event_details':'', }})}>FAQ</Link> 
                        </nav>
                        <div className="ac-border-line"></div>

                        {/* <h4 className="sites-logos-header">
                              For More Deals:
                        </h4> */}
                        
                        {/* <div className="sites-logos">

            
                              <div className="anoter-site-deal-logo">
                                    <a rel="noopener noreferrer" href="https://www.booking.com/city/il/tel-aviv.html?label=gen173nr-1FCAMoakIIdGVsLWF2aXZIM2IFbm9yZWZoaogBAZgBMcIBCndpbmRvd3MgMTDIAQzYAQHoAQH4AQKSAgF5qAID;sid=785bc6b4149c4ea015b7faaa573cff20;inac=0&amp;" target="_blank">
                                          <Img desktopImg="Footer/1.png" />
                                    </a>
                              </div>
                              <div className="anoter-site-deal-logo">
                                    <a rel="noopener noreferrer" href="https://www.expedia.co.uk/Tel-Aviv.d180031.Holidays-City-Breaks" target="_blank">
                                          <Img desktopImg="Footer/2.png" />
                                    </a>
                              </div>
                              <div className="anoter-site-deal-logo">
                                    <a rel="noopener noreferrer" href="https://www.hotels.com/de699178/hotels-tel-aviv-israel/?pos=HCOM_US&amp;locale=en_US" target="_blank">
                                          <Img desktopImg="Footer/3.png" />
                                    </a>
                              </div>
                              <div className="anoter-site-deal-logo">
                                    <a rel="noopener noreferrer" href="https://www.tripadvisor.co.uk/Hotels-g293984-Tel_Aviv_Tel_Aviv_District-Hotels.html" target="_blank">
                                          <Img desktopImg="Footer/4.png"/>
                                    </a>
                              </div>
                              <div className="anoter-site-deal-logo">
                                    <a rel="noopener noreferrer" href="https://www.trivago.com/?aDateRange%5Barr%5D=2017-10-15&amp;aDateRange%5Bdep%5D=2017-10-16&amp;aPriceRange%5Bfrom%5D=0&amp;aPriceRange%5Bto%5D=0&amp;iPathId=84948&amp;iGeoDistanceItem=0&amp;aCategoryRange=0%2C1%2C2%2C3%2C4%2C5&amp;aOverallLiking=1%2C2%2C3%2C4%2C5&amp;bTopDealsOnly=false&amp;iRoomType=7&amp;cpt=8494803&amp;iIncludeAll=0&amp;iViewType=0&amp;bIsSeoPage=false&amp;bIsSitemap=false&amp;" target="_blank">
                                          <Img desktopImg="Footer/5.png" />
                                    </a>
                              </div>
                              <div className="anoter-site-deal-logo">
                                    <a rel="noopener noreferrer" href="https://www.orbitz.com/Destinations-In-Israel.d85.Flight-Destinations" target="_blank">
                                          <Img desktopImg="Footer/6.png" />
                                    </a>
                              </div>
                              <div className="anoter-site-deal-logo">
                                    <a rel="noopener noreferrer" href="https://www.cheapflights.com/flights-to-israel/usa/" target="_blank">
                                          <Img desktopImg="Footer/7.png" />
                                    </a>
                              </div>
                              <div className="anoter-site-deal-logo">
                                    <a rel="noopener noreferrer" href="https://www.travelocity.com/Cheap-Flights-To-Tel-Aviv.d180031.Travel-Guide-Flights" target="_blank">
                                          <Img desktopImg="Footer/8.png" />
                                    </a>
                              </div>
                              <div className="anoter-site-deal-logo">
                                    <a rel="noopener noreferrer" href="https://www.kayak.com/flight-routes/Orlando-MCO/Israel-IL0" target="_blank">
                                          <Img desktopImg="Footer/9.png" />
                                    </a>
                              </div>


                        </div> */}

                        
                        <div className="clear"></div>
             </div>
            </div>
    </div>
  )
}

export default Footer


// WEBPACK FOOTER //
// ./src/Components/Footer/Footer.js